import { call, put, takeLatest } from "@redux-saga/core/effects";
import { jarvisPrimeTransactionConstants } from "./jarvisPrimeTransactionConstants";
import { jarvisPrimeTransactionApis } from "./jarvisPrimeTransactionApis";
import { jarvisPrimeTransactionParsers } from "./jarvisPrimeTransactionParsers";

function* jarvisPrimeTransactionListSaga({ payload }) {
  const { page, rowsPerPage } = payload;
  try {
    yield put({
      type: jarvisPrimeTransactionConstants.PRIME_TRANSACTION_LIST_REQUEST,
    });

    const res = yield call(jarvisPrimeTransactionApis.getTransactionList, {
      page,
      rowsPerPage,
    });
    const data = jarvisPrimeTransactionParsers.transactionParser(res);
    let count = 0;
    if (res.count) {
      count = res.count;
    }

    yield put({
      type: jarvisPrimeTransactionConstants.PRIME_TRANSACTION_LIST_RESPONSE,
      payload: { data, count },
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeTransactionConstants.PRIME_TRANSACTION_LIST_RESPONSE,
      payload: [],
    });
  }
}

export function* registerjarvisPrimeTransactionListSaga() {
  yield takeLatest(
    jarvisPrimeTransactionConstants.PRIME_TRANSACTION_LIST_SAGA,
    jarvisPrimeTransactionListSaga
  );
}
